import DocViewer, {
  DocViewerRenderers,
  IDocument,
} from '@cyntler/react-doc-viewer';

type DocumentViewerProps = {
  documents?: IDocument[];
};

const DocumentViewer = (props: DocumentViewerProps) => {
  const { documents } = props;
  return (
    <DocViewer
      prefetchMethod='GET'
      pluginRenderers={DocViewerRenderers}
      documents={documents ?? []}
      config={{ header: { disableHeader: false, retainURLParams: false } }}
    />
  );
};

export default DocumentViewer;

DocumentViewer.defaultProps = {
  documents: undefined,
};
